import React, { useMemo } from 'react';
import { computeSummary, formatNumber } from './utils/formatters';

/**
 * Summary footer row — shows sum/avg/min/max for numeric columns.
 * Only renders if at least one column has a `summary` property.
 */
function TableFooter({ visibleColumns, data, columns, stickyOffsets = {} }) {
    const hasSummary = visibleColumns.some((col) => col.summary);

    const summaryValues = useMemo(() => {
        if (!hasSummary || !data.length) return null;

        return visibleColumns.map((col) => {
            if (!col.summary) return null;

            const realIdx = columns.indexOf(col);
            const values = data.map((row) =>
                Array.isArray(row) ? row[realIdx] : row[col.key]
            );

            const result = computeSummary(values, col.summary);
            if (result === '-') return '-';
            return formatNumber(result);
        });
    }, [visibleColumns, data, columns, hasSummary]);

    if (!hasSummary || !summaryValues) return null;

    const summaryLabels = {
        sum: 'Сумма',
        avg: 'Среднее',
        min: 'Мин',
        max: 'Макс',
        count: 'Кол-во',
    };

    return (
        <tfoot className="ut-tfoot">
            <tr className="ut-tr ut-tr--footer">
                {/* Row actions cell */}
                <td className="ut-td ut-td--footer ut-td--sticky" style={{ left: 0 }}>
                    Σ
                </td>
                {visibleColumns.map((col, idx) => {
                    // Закреплённые колонки должны быть закреплены и в итоге:
                    // иначе при горизонтальной прокрутке итоговые числа уезжают
                    // из-под своих заголовков.
                    const stickyLeft = stickyOffsets[col.key];
                    const isSticky = stickyLeft != null;
                    const style = { width: col.width || undefined };
                    if (isSticky) style.left = stickyLeft;
                    return (
                    <td
                        key={col.key}
                        style={style}
                        className={[
                            'ut-td', 'ut-td--footer',
                            isSticky ? 'ut-td--sticky' : '',
                            col.align === 'right' ? 'ut-td--right' : '',
                        ].filter(Boolean).join(' ')}
                    >
                        {summaryValues[idx] != null ? (
                            <div className="ut-footer-cell">
                                <span className="ut-footer-label">
                                    {summaryLabels[col.summary] || ''}
                                </span>
                                <span className="ut-footer-value">{summaryValues[idx]}</span>
                            </div>
                        ) : null}
                    </td>
                    );
                })}
            </tr>
        </tfoot>
    );
}

export default React.memo(TableFooter);
